import { Link } from 'react-router-dom';
import CopyCode from '../components/CopyCode';

// Fixed (not random-on-render) spread so it doesn't reshuffle every re-render
// — just deterministic pseudo-variety across left position / timing / color.
const EMBER_COLORS = ['#ff544a', '#F6BB42', '#00f0ff'];
const EMBERS = Array.from({ length: 16 }, (_, i) => ({
  left: (i * 47 + 9) % 100,
  delay: (i * 0.7) % 8,
  duration: 7 + (i % 5) * 1.4,
  size: 2 + (i % 3),
  color: EMBER_COLORS[i % EMBER_COLORS.length],
}));

const DECOR = [
  {
    alt: 'Gun',
    pos: 'top-[5%] left-[2%]',
    opacity: 'opacity-60',
    delay: '0s',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD2zqj1PjoA3ybVOhS8wCjETJebd4MY-3a9ELKd5g5v7VQlcEeejt3ewPtLGjZRFj_0rTJXr9aGgayN6_NdIiJKIkEjSPC2uZ3PEHVnirg4ts6etjZ1ul6LxtEwH-RSBEsVsFXYMG4QMZeATQ1s2zs5_AE4wbqPKfZGDIGDGjMbh6hLevWCisG3nzYB32PHKGhGO0KY8JIJ74Iea46fEaab1SRr-xlm0NsXaqQ37Tt1lPZmmOUJ_Dvn8ZZ_RXCcyaIOFQ',
  },
  {
    alt: 'Star',
    pos: 'bottom-[10%] left-[6%]',
    opacity: 'opacity-70',
    delay: '1.5s',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD4BmVgQFAAyqu4JoGQTpuYTFzhfwO9RUONVhIKbdXkBEjGwUApJUi046D7d2lvLXjR1emENjf-q8vhzAvyw934ZTJxF5TxdULSfv39UpnWbH9x0KlhkLgYe-eeQqHL0ilwTwwmcLb4hnTa_sbQxodBuGsHdsRuHqzfMtKjSdMTvX9bLIbNXKthtp9CgVyyhXemjKHQn0mavjVT-TEmQf2BbD74-sT1f6KzWqKBRYWLx-CO43wxMITjOY2C3PHIzoyIzw',
  },
  {
    alt: 'Lock',
    pos: 'top-[5%] right-[2%]',
    opacity: 'opacity-80',
    delay: '3s',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAeGlT-9OWIHc1nljD2_WafxV1fgbIbyhCUw-yZO2LVwj0xoAUumSp1kEFy95hHS-ZFDERx14jABUGrN__sGdOGSYOF4Ujd2xb3dEt2CkL4B2TnoJyZxi9-4HDqg-fO8TAklQk2-wbbGFpLQMZw9_Y6hi91VNuURDGGF6LWmPBQXotNAyaFm204UTyTVBvR4RIfWtGDnHPAy2l8PBY0XU6r-H8kC4eXQFyVDRDMRrEQIHAdZLivDtJkXzd2pQLkK4PVTw',
  },
  {
    alt: 'Star',
    pos: 'bottom-[10%] right-[6%]',
    opacity: 'opacity-60',
    delay: '4.5s',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD4BmVgQFAAyqu4JoGQTpuYTFzhfwO9RUONVhIKbdXkBEjGwUApJUi046D7d2lvLXjR1emENjf-q8vhzAvyw934ZTJxF5TxdULSfv39UpnWbH9x0KlhkLgYe-eeQqHL0ilwTwwmcLb4hnTa_sbQxodBuGsHdsRuHqzfMtKjSdMTvX9bLIbNXKthtp9CgVyyhXemjKHQn0mavjVT-TEmQf2BbD74-sT1f6KzWqKBRYWLx-CO43wxMITjOY2C3PHIzoyIzw',
  },
];

const BONUSES = [
  {
    name: 'Rain.gg',
    logo: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAJMA0q8cnZBK2ZXR6b0e419B0xqqWqU2kxpZO3cUy2hxPLiz6OsJ281R75E0-lsryO2C-a9WV4_vKi-OO4UhZmNCU1KP7o6JFeH8VUJsgMvOL0p1Pj3v2cZ4CkizaMQgE3Tx3mP0ngxP5Jp1lId05CJ1BR50heHM2HSGloeUCQoTBfaSbvWy2YveZXVBAKUvdFcbiEQ8WXPz3YoFc9AoX-Q6MnKEW2qcZ2SSlCrL_JrpAoK7rzTJMdDMf8Q31NcZ7UgA',
    logoH: 'h-10',
    bullets: ['+5% Lossback', 'Wager Milestone Rewards'],
    code: 'FREEMAN',
    href: 'https://rain.gg/r/FreeMan',
  },
  {
    name: 'Unbox',
    logo: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCj-bwUMTxfGyec1PjFqZsbiGzKilUQHKuh5vjxpSyufH7LCKN1lozeWYT8g1S-dXj_e2u_PNwykxWqB-xVKW320QmbkrE8ZCjCWyYfIS69mzvWy0kOfyW-fB4Iy-fppZwxULD8p9FRjYWAuosVpAEbXRf3ui045oc-XYsbapCRpBm58oCKnR5TaLMnBpG9yQpk5JYcxwN-aOuba6r_r9YX489uQo5XPSSaTo4Jf1yVT3dsF1JmbbjSGxxxzfrDkaqTTw',
    logoH: 'h-8',
    bullets: ['+5% Deposit Bonus', 'Wager Milestone Rewards'],
    code: 'FREEMAN',
    href: 'https://unbox.gg/en?r=FreeMan',
  },
  {
    name: 'BetDice',
    logo: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDS5FTzaZCT1SJSGHTnqZd0mrD4oLkajRAUpiWRLpZsqHRHBH8EcPXdWANvjzlgemr_pGYRHxnRNyXPSUnTQ-Q-L-6DR94eLZRBO3zBtljRqcMpefwGi5SmFGleiujQNIYK8ppQki7wO9eslP03XfEH9x3Ht1aicQBO8EwpHF2hBtmxkefd20YYg1JNT0wVfylIYeQcQWLrenhke7F9HmaLWdlNL8MIQHm2F6GGCTMrjeLl6S5sheHGwpDa8sFAjWF2aQ',
    logoH: 'h-10',
    bullets: ['Instant Rakeback', 'Wager Milestone Rewards'],
    code: 'JuiceUp',
    href: 'https://betdice.click/r/juiceup',
  },
  {
    name: 'Cases.gg',
    logo: '/images/casesgg-logo.png',
    logoH: 'h-8',
    bullets: ['Up to 200% Deposit Bonus', 'Rakeback'],
    code: 'FREEMAN',
    href: 'https://cases.gg/r/FREEMAN',
  },
  {
    name: 'Winovo',
    logo: '/images/winovo-logo.png',
    logoH: 'h-10',
    bullets: ['Up to 20% Deposit Bonus', 'Wager Milestone Rewards'],
    code: 'FREEMAN',
    href: 'https://winovo.io/?ref=FreeMan',
  },
];

function DiscordIcon() {
  return (
    <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037 19.736 19.736 0 0 0-4.885 1.515.069.069 0 0 0-.032.027C.533 9.048-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.196.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </svg>
  );
}
function XIcon() {
  return (
    <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}
function YouTubeIcon() {
  return (
    <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

const SOCIALS = [
  {
    name: 'Discord',
    handle: '@amnotraimiuxsas',
    href: 'https://discord.gg/ubnZnbsvCv',
    icon: <DiscordIcon />,
    iconBg: 'bg-[#5865F2]/10',
    iconColor: 'text-[#5865F2]',
    hoverShadow: '0 0 20px rgba(88,101,242,0.4)',
  },
  {
    name: 'Kick',
    handle: '@freemanslive',
    href: 'https://kick.com/freemanslive',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCY9ZX6i6-nqWMl_HoYCGu3NmlIZHlpHNJQl1ZTBFHIr1DMbjATqG3a9ffQHsD-TzcRpmqCHC4he4lOnS6rbPJYDw4js97M-b2-vCrjW7oFmr_ojKI7SbsbuRBu45pSugYvQEIA4l_11YVuD-qdVZ-N5E6koji_Wnxcgkv_tiAT8HJ6UKmmwqawcniLljc-1FguBdvyr87_lVpdmyuHd1RZ4KiMMyKwmYNLzF-YGLk6bpNXALEty2vgAPVpDGaJk9Mdlg',
    iconBg: 'bg-[#00E701]/10',
    iconColor: 'text-[#00E701]',
    hoverShadow: '0 0 20px rgba(83,252,24,0.4)',
  },
  {
    name: 'X / Twitter',
    handle: '@FreeManThe3',
    href: 'https://x.com/FreeManThe3',
    icon: <XIcon />,
    iconBg: 'bg-white/10',
    iconColor: 'text-white',
    hoverShadow: '0 0 20px rgba(255,255,255,0.3)',
  },
  {
    name: 'YouTube',
    handle: 'Coming soon!',
    disabled: true,
    icon: <YouTubeIcon />,
    iconBg: 'bg-[#FF0000]/10',
    iconColor: 'text-[#FF0000]',
  },
];

export default function Home() {
  return (
    <div className="w-full relative">
      {/* Hero */}
      <section
        id="home"
        className="max-w-[1200px] mx-auto px-6 mb-16 flex flex-col items-center text-center mt-12 relative overflow-hidden"
      >
        <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
          {EMBERS.map((e, i) => (
            <span
              key={i}
              className="ember"
              style={{
                left: `${e.left}%`,
                width: e.size,
                height: e.size,
                background: e.color,
                boxShadow: `0 0 ${e.size * 3}px ${e.color}`,
                animationDelay: `${e.delay}s`,
                animationDuration: `${e.duration}s`,
              }}
            />
          ))}
        </div>
        {DECOR.map((d, i) => (
          <img
            key={i}
            alt={d.alt}
            className={`absolute ${d.pos} w-16 md:w-24 ${d.opacity} pointer-events-none float-hero`}
            style={{ animationDelay: d.delay }}
            src={d.src}
          />
        ))}

        <div className="w-full py-28 px-6 rounded-xl relative overflow-hidden flex flex-col items-center justify-center text-center z-10">
          <h1
            className="hero-title-glow font-display-lg font-black tracking-tight text-white mb-5 relative z-10"
            style={{ fontSize: 'clamp(2.75rem, 7vw, 5.5rem)', lineHeight: 1.05 }}
          >
            Welcome to{' '}
            <span className="text-[#00f0ff] drop-shadow-[0_0_20px_rgba(0,240,255,0.7)]">FREEMAN</span>
            's club
          </h1>
          <p
            className="text-white italic font-title-md opacity-90 max-w-2xl relative z-10"
            style={{ fontSize: 'clamp(1rem, 2vw, 1.35rem)' }}
          >
            Wager under code <span className="text-[#00f0ff] font-bold">FREEMAN</span> - the most rewarding
            code out there!
          </p>
        </div>
      </section>

      {/* Featured bonuses */}
      <section id="bonuses" className="max-w-[1200px] mx-auto px-6 mb-20 mt-8">
        <h2 className="scroll-reveal text-2xl sm:text-3xl font-display-lg text-[#ff544a] text-center mb-12 uppercase tracking-wide font-black drop-shadow-[0_0_10px_rgba(255,84,74,0.4)]">
          FEATURED BONUSES
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {BONUSES.map((b, i) => (
            <div
              key={b.name}
              className="bonus-card scroll-reveal bg-[#0B0B14] border border-[#ff544a]/20 hover:border-[#ff544a]/60 rounded-xl p-8 flex flex-col items-center transition-all hover:shadow-[0_0_30px_rgba(255,84,74,0.3)]"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="h-16 flex items-center justify-center mb-6 w-full border-b border-[#ff544a]/10 pb-6">
                <img alt={b.name} className={`${b.logoH} object-contain`} src={b.logo} />
              </div>
              <div className="flex-grow w-full mb-8">
                <ul className="space-y-3 text-sm font-title-md">
                  {b.bullets.map((bullet) => (
                    <li key={bullet} className="flex items-center gap-2 text-white/80">
                      <span className="material-symbols-outlined text-[#ff544a] text-lg">check</span>
                      {bullet}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="w-full space-y-4">
                <div className="text-center">
                  <div className="text-[10px] font-mono text-[#888899] uppercase tracking-widest mb-2">Code</div>
                  <div className="flex justify-center">
                    <CopyCode textToCopy={b.code} />
                  </div>
                </div>
                <a
                  className="btn-primary shine-hover w-full py-3.5 flex justify-center items-center rounded-lg text-sm font-bold tracking-wider"
                  href={b.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CLAIM
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Connect / social tiles */}
      <section className="max-w-[1200px] mx-auto px-6 mb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full max-w-5xl mx-auto">
          {SOCIALS.map((s, i) => {
            const Tag = s.disabled ? 'div' : 'a';
            return (
              <Tag
                key={s.name}
                {...(!s.disabled && { href: s.href, target: '_blank', rel: 'noopener noreferrer' })}
                className={`social-tile scroll-reveal bg-[#0B0B14] border border-[#ff544a]/10 rounded-lg p-4 flex items-center gap-4 transition-all group ${
                  s.disabled ? 'opacity-60 cursor-not-allowed' : 'hover:border-[#ff544a]/40'
                }`}
                style={{ transitionDelay: `${i * 70}ms` }}
                onMouseEnter={(e) => {
                  if (!s.disabled && s.hoverShadow) e.currentTarget.style.boxShadow = s.hoverShadow;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '';
                }}
              >
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded ${s.iconBg} ${s.iconColor} ${
                    s.disabled ? '' : 'group-hover:scale-110'
                  } transition-transform`}
                >
                  {s.img ? <img alt={s.name} className="w-8 h-8 object-contain" src={s.img} /> : s.icon}
                </div>
                <div className="flex flex-col">
                  <span className="text-[10px] font-mono text-[#888899] uppercase tracking-widest">{s.name}</span>
                  <span className={`font-bold ${s.disabled ? 'text-[#888899]/60' : 'text-[#ff544a]'}`}>
                    {s.handle}
                  </span>
                </div>
              </Tag>
            );
          })}
        </div>
      </section>

      {/* TOS */}
      <section id="tos" className="scroll-reveal max-w-3xl mx-auto px-6 mb-16 text-center">
        <h2 className="text-xl font-display-lg text-white/80 mb-4 uppercase tracking-widest font-bold">
          TERMS &amp; PRIVACY
        </h2>
        <p className="text-sm mb-6 text-white/60 font-body-md leading-relaxed">
          By using Freeman Terms, you agree to our Terms of Service and Privacy Policy. All promotions and
          leaderboards are subject to change. Must be 18+ to participate where applicable by law.
        </p>
        <div className="flex justify-center items-center gap-4 text-sm font-bold font-mono tracking-wide">
          <Link to="/terms" className="text-[#ff544a] hover:underline transition-colors cursor-pointer">
            Read Terms of Service
          </Link>
          <span className="text-[#353535]">|</span>
          <Link to="/privacy" className="text-[#ff544a] hover:underline transition-colors cursor-pointer">
            Read Privacy Policy
          </Link>
        </div>
      </section>
    </div>
  );
}
